export const sidebarTokens = [
	{
		name: "Tether",
		symbol: "USDT",
		decimals: 6,
		address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
		iconUrl: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663"
	},
	{
		name: "USD Coin",
		symbol: "USDC",
		decimals: 6,
		address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
		iconUrl: "https://assets.coingecko.com/coins/images/6319/small/usdc.png?1696506694"
	},
	{
    name: 'THE BULLS ARMY',
    symbol: 'TBA',
    decimals: 18,
    address: '0x7e1ae068ac4e0ffd7a84750c2fb093a0eae9aea2',
    iconUrl:
      'https://dd.dexscreener.com/ds-data/tokens/polygon/0x7e1ae068ac4e0ffd7a84750c2fb093a0eae9aea2.png?size=lg&key=ad7401',
  },
  {
    name: 'X BULL RUN',
    symbol: 'XBR',
    decimals: 18,
    address: '0xd44caebbf5c5a3848357ec05e24220bebef41d40',
    iconUrl: 'https://i.imgur.com/aEnTpcp.png',
  },
]